import auth from './auth'

const SUJET_MAPPING = {
    "11": {
        sujet_parent: 4,
        sujet: 24,
    },
    "12": {
        sujet_parent: 1,
    },
    "13": {
        sujet_parent: 4,
    },
    "14": {
        sujet_parent: 7,
    },
    "15": {
        sujet_parent: 6,
        sujet: 42,
    },
    "2": {
        sujet_parent: 6,
    }
}

export default {
    state: {
        websocket: null,
        calls: [],
    },

    mutations: {
        setWebsocket: function (state, websocket) {
            state.websocket = websocket
        },
        newCall: function (state, call) {
            state.calls.push(call)
        },
        addDigit: function (state, {call_id, digit}) {
            const call = state.calls.find(call => call.call_id === call_id)
            if (call) {
                call.digits = call.digits ? call.digits : []
                call.digits.push(digit)
            }
        },
        deleteCall: function (state, call_id) {
            state.calls = state.calls.filter(call => call.call_id !== call_id)
        }
    },

    getters: {
        getDigits: (state) => (call_id) => {
            const call = state.calls.find(call =>call.call_id === call_id)
            if (call && call.digits) {
                return call.digits.join('')
            }
            return null
        }
    },

    actions: {
        init: function (context) {
            context.dispatch('initWazo')
        },

        initWazo: function (context) {
            axios.get('/api/wazo').then(response => {
                const websocket = new WebSocket(response.data.data.uri)
                websocket.onclose = function () {
                    context.commit('setWebsocket', null)
                    context.dispatch('initWazo')
                }

                websocket.onmessage = function (event) {
                    const msg = JSON.parse(event.data)
                    switch (msg.op) {
                        case 'init':
                            websocket.send(JSON.stringify({ op: 'subscribe',  data: { event_name: '*' }}))
                            websocket.send(JSON.stringify({ op: 'start' }))
                            break
                        case 'event':
                            switch (msg.data.name) {
                                case 'call_created':
                                    processCallCreated(context, msg.data.data)
                                    break
                                case 'call_dtmf_created':
                                    const data = msg.data.data
                                    context.commit('addDigit', {call_id: data.call_id, digit:data.digit})
                                    break
                                case 'call_updated':
                                    processCallUpdated(context, msg.data.data)
                                    break
                                case 'call_ended':
                                    context.commit('deleteCall', msg.data.data.call_id)
                                    break
                            }
                            break
                    }
                }

                context.commit('setWebsocket', websocket)
            })
        }
    },
}

function processCallCreated(context, data) {
    if (!data.caller_id_name) {
        context.commit('newCall', {call_id: data.call_id})
    }
}

function processCallUpdated(context, data) {
    /**
     * Permet de ne pas prendre en compte les appels internes
     */
    if (data.direction !== 'inbound') {
        return
    }

    /**
     * Filtre appels qui sont attribués à quelqu'un d'autre
     */
    if (identifyUser(data)) {
        sendNotification(context, data.caller_id_number, data.call_id)
    }
}

function sendNotification(context, telephone, call_id) {
    const digits = context.getters.getDigits(call_id)
    const sujet = digits ? SUJET_MAPPING[digits] : null

    axios.get('/api/dossiers', { params: { telephone } })
        .then((response) => {
            const data = response.data.data

            if (!data.length) {
                return
            }
            const exercice = data.sort( (a, b) => b.exercice - a.exercice)[0].exercice
            const dossiers = data.filter((dossier) => dossier.exercice === exercice)

            const idClient = dossiers[0] ? dossiers[0].id : null

            let dossier = null
            if (idClient)
            {
                dossier = {
                    nom: dossiers[0].client.nom || dossiers[0].client.libelle_indivision,
                    prenom: dossiers[0].client.prenom ||  dossiers[0].client.type_indivision,
                    cegid: dossiers[0].cegid,
                }
            }
            context.commit('popCall')
            context.commit('addCall', { idClient, dossier, phone: telephone, sujet, dossierNumber: dossiers.length})
        })
}

function identifyUser(data) {
    return auth.state.user && (
        (
            (auth.state.user.telephone) &&
            auth.state.user.telephone.endsWith(data.peer_caller_id_number)
        )
        || (auth.state.user.wazo_id && auth.state.user.wazo_id === data.user_uuid)
    )
}
